module.exports = __webpack_public_path__ + "static/img/system_name.6e00827.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/system_name.png
// module id = 528
// module chunks = 1